import React, { Component } from "react";
import { connect } from "react-redux";

import { StyledCard, StyledContent, StyledHeader } from "../../styles";

import { Remove as RemoveIcon, Add as AddIcon } from "@material-ui/icons";
import {
    getSeats,
    getSeatLimit,
    getUsers,
    saveChanges,
    updateLimit,
} from "./actions";
import "./components/style.css";
import { selectSeats, selectSeatLimit, selectUsers } from "./selectors";
import {
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Typography,
    Button,
    TextField,
    Grid,
} from "@material-ui/core";

class SeatedUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seats: [],
            seatLimit: 1,
        };
        props.getSeats();
        props.getSeatLimit();
        props.getUsers();
    }
    componentDidUpdate() {
        if (this.props.seats !== this.state.seats)
            this.setState({ seats: this.props.seats });
    }
    isSeated(uid) {
        return this.state.seats.includes(uid);
    }
    render() {
        const { seats } = this.state;
        const { users, seatLimit } = this.props;
        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5">Seated Users</Typography>
                </StyledHeader>

                <StyledContent style={{ paddingTop: "0px" }}>
                    {typeof seatLimit !== "undefined" && seatLimit !== null && (
                        <TextField
                            label="Seat Limit"
                            value={seatLimit}
                            style={{ margin: 24 }}
                            type="number"
                            onChange={(event) => {
                                this.props.updateLimit(
                                    Number(event.target.value)
                                );
                            }}
                        />
                    )}
                    {users && (
                        <>
                            <Grid container style={{ padding: 24 }} spacing={3}>
                                <Grid
                                    item
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={12}
                                    style={{
                                        borderRight: "1px solid lightgray",
                                    }}
                                >
                                    <Typography
                                        variant="display1"
                                        style={{
                                            marginLeft: 24,
                                            marginTop: 24,
                                            color: "#32b228",
                                        }}
                                    >
                                        Seated
                                        <span style={{ fontSize: 14 }}>
                                            (Limit: {seatLimit ? seatLimit : 0})
                                        </span>
                                    </Typography>

                                    <List>
                                        {users.map((e) => {
                                            if (this.isSeated(e.uid))
                                                return (
                                                    <ListItem
                                                        key={e.uid}
                                                        style={{
                                                            borderLeft:
                                                                "3px solid #32b228",
                                                            marginBottom: 6,
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={
                                                                e.first_name +
                                                                " " +
                                                                e.last_name
                                                            }
                                                        />
                                                        <ListItemSecondaryAction>
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => {
                                                                    let item = seats;

                                                                    let index = 0;
                                                                    item.map(
                                                                        (
                                                                            r,
                                                                            i
                                                                        ) => {
                                                                            if (
                                                                                r ===
                                                                                e.uid
                                                                            )
                                                                                index = i;
                                                                            return null;
                                                                        }
                                                                    );
                                                                    item = item.splice(
                                                                        index,
                                                                        1
                                                                    );

                                                                    this.setState(
                                                                        {
                                                                            seats: item,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <RemoveIcon />
                                                            </IconButton>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                );
                                            return null;
                                        })}
                                    </List>
                                </Grid>
                                <Grid item xl={6} lg={6} md={6} sm={12}>
                                    <Typography
                                        variant="display1"
                                        style={{
                                            marginLeft: 24,
                                            marginTop: 24,
                                            color: "red",
                                        }}
                                    >
                                        Non-Seated
                                    </Typography>

                                    <List>
                                        {users.map((e) => {
                                            if (!this.isSeated(e.uid))
                                                return (
                                                    <ListItem
                                                        key={e.uid}
                                                        style={{
                                                            borderLeft:
                                                                "3px solid red",
                                                            marginBottom: 6,
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={
                                                                e.first_name +
                                                                " " +
                                                                e.last_name
                                                            }
                                                        />
                                                        <ListItemSecondaryAction>
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => {
                                                                    let item =
                                                                        seats ||
                                                                        [];
                                                                    item.push(
                                                                        e.uid
                                                                    );

                                                                    if (
                                                                        item.length <=
                                                                        seatLimit
                                                                    )
                                                                        this.setState(
                                                                            {
                                                                                seats: item,
                                                                            }
                                                                        );
                                                                }}
                                                            >
                                                                <AddIcon />
                                                            </IconButton>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                );
                                            return null;
                                        })}
                                    </List>
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Button
                        onClick={() => {
                            this.props.saveChanges(this.state.seats, seatLimit);
                        }}
                        color="primary"
                        variant="contained"
                        style={{ marginTop: 24 }}
                    >
                        Save Changes
                    </Button>
                </StyledContent>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            seats: selectSeats(store),
            seatLimit: selectSeatLimit(store),
            users: selectUsers(store),
        };
    },
    { getSeats, getSeatLimit, getUsers, saveChanges, updateLimit }
)(SeatedUsers);
